import { SpraypaintBase, MiddlewareStack, Model } from "spraypaint";

@Model()
class ApplicationRecord extends SpraypaintBase {
  static baseUrl = "";

  static apiNamespace = "/api/v1";
}

const middleware = new MiddlewareStack();
const tokenDom = document.querySelector<HTMLMetaElement>(
  "meta[name=csrf-token]"
);
middleware.beforeFilters.push((url, options) => {
  if (tokenDom) {
    const csrfToken = tokenDom.content;
    options.headers["X-CSRF-TOKEN"] = csrfToken; // eslint-disable-line no-param-reassign
  }
});

ApplicationRecord.middlewareStack = middleware;

export default ApplicationRecord;
